<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/eRY7VD/tc-custom/9781480404830.jpg?1703906065516" alt="This image is the cover for the book Wolf Gang, The He-Man Women Haters Club"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Wolf Gang, The He-Man Women Haters Club
      </h1>
      <p class="bookDescription body article font2">
        <b>Nothing breaks the heart of a He-Man Women Hater like one of their own joining ranks with the girls!</b>When Wolf forms his own club in a beauty shop with the Girl Scouts as members, the He-Man Women Haters take it as a declaration of war. Then Jerome strays from the group after visiting the beauty shop, and Steven knows he must take action, letting a girl into his club. But soon the He-Men realize they are in over their heads! The final book in the He-Man Women Haters Club series is filled with betrayal, defections, and double agents as Wolf and Steven face off. It’s an all-out war, and only the best club will survive.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Chris Lynch
      </h2>
      
      <p class="authorDescription body article">Chris Lynch (b. 1962), a Boston native, is an award-winning author of several acclaimed young adult novels, including&#160;<i>Freewill&#160;</i>(2001), which won the Michael L. Printz Honor, and National Book Award finalist&#160;<i>Inexcusable</i>&#160;(2005). Lynch holds an MA from the writing program at Emerson College, and teaches in the creative writing MFA program at Lesley University. He mentors aspiring writers and continues to work on new literary projects while splitting time between Boston and Scotland.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7f373044